import React from 'react';
import { useTranslation } from 'react-i18next';
import BrandLockup from './BrandLockup';
import '../styles/postLandingShared.css';

/**
 * Shared shell for Success and Welcome (post-login): brand header, hero block, list card, CTA, legal footer.
 */
export default function PostLandingShell({
  headerAside = null,
  onBrandClick,
  pageClassName = '',
  hero = null,
  badge,
  title,
  titleClassName = 'gm-pl-title',
  subtitle,
  listItems,
  footnote,
  extraContent = null,
  primaryLabel,
  onPrimary,
  secondaryLabel,
  onSecondary,
  backLinkLabel,
  onBackLink,
}) {
  const { t } = useTranslation();

  return (
    <div className={`gm-pl-page${pageClassName ? ` ${pageClassName}` : ''}`}>
      <header className="gm-pl-header">
        <div className="gm-pl-header-row">
          <button type="button" className="border-none bg-transparent p-0 text-left" onClick={onBrandClick}>
            <BrandLockup
              containerClassName="gm-pl-brand"
              logoClassName="gm-pl-logo"
              textWrapperClassName="gm-pl-brand-copy"
              titleClassName="gm-pl-brand-title"
              subtitleClassName="gm-pl-brand-subtitle"
              title={t('successPage.brandTitle')}
              subtitle={t('successPage.brandSubtitle')}
            />
          </button>
          {headerAside ? <div className="gm-pl-header-aside">{headerAside}</div> : null}
        </div>
      </header>

      <main className="gm-pl-main">
        <div className="gm-pl-content">
          {hero ?? (
            <div className="gm-pl-check" aria-hidden="true">
              <i className="ri-check-line" />
            </div>
          )}

          <span className="gm-pl-badge">{badge}</span>
          <h1 className={titleClassName}>{title}</h1>
          {subtitle}

          <div className="gm-pl-list-card">
            <ul className="gm-pl-list">
              {listItems.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          {extraContent}

          <div className="gm-pl-actions">
            <button type="button" className="gm-pl-primary-btn" onClick={onPrimary}>
              {primaryLabel}
            </button>
            {secondaryLabel && onSecondary ? (
              <button type="button" className="gm-pl-secondary-btn" onClick={onSecondary}>
                {secondaryLabel}
              </button>
            ) : null}
          </div>

          {backLinkLabel && onBackLink ? (
            <button type="button" className="gm-pl-back-link" onClick={onBackLink}>
              {backLinkLabel}
            </button>
          ) : null}

          <p className="gm-pl-footnote">{footnote}</p>
        </div>
      </main>

      <footer className="gm-pl-footer">
        <div className="gm-pl-footer-inner">
          <p className="gm-pl-company">
            {t('successPage.companyLine1')}{' '}
            <span>{t('successPage.companyName')}</span>, {t('successPage.companyAddress')}. {t('successPage.companyLine2')}{' '}
            <a href="mailto:legal@globalmobility.law">legal@globalmobility.law</a>
          </p>
          <div className="gm-pl-links">
            <a href="https://globalmobility.law/terminos-servicio">{t('successPage.linkTerms')}</a>
            <span aria-hidden="true">·</span>
            <a href="https://globalmobility.law/politica-privacidad">{t('successPage.linkPrivacy')}</a>
            <span aria-hidden="true">·</span>
            <a href="https://globalmobility.law/politica-cookies">{t('successPage.linkCookies')}</a>
            <span aria-hidden="true">·</span>
            <a href="https://globalmobility.law/aviso-legal">{t('successPage.linkLegal')}</a>
          </div>
          <p className="gm-pl-copy">{t('successPage.copyright')}</p>
        </div>
      </footer>
    </div>
  );
}
